<template>
	<div class="view">
		<div class="left">
			<div class="title">Конкурс</div>
			<div class="text">
				Чтобы получить татуировку от Олега Турянского, расскажите, почему она должна достаться именно вам — и не забудьте оставить контактные данные. Автор лучшего объяснения получит тату, а еще 10 участников — пригласительные на
				<router-link class="link" to="/contest">тату-конвенцию</router-link>&#160;платформы
				<a
					href="http://made-for.ru/?utm_source=lenta&utm_medium=logo&utm_campaign=bulleittattoo"
					target="_blank"
					class="link"
				>Made For.</a>
			</div>

			<uiDevider/>

			<router-link to="/form">
				<uiButton color="dark" class="button">Участвовать</uiButton>
			</router-link>

			<a
				class="rules"
				href="/rules.pdf"
				target="_blank"
				@click="ga('send', 'event', 'link', 'rules')"
			>Полные правила</a>
		</div>
		<div class="right"></div>
		<div class="video" v-if="videoOpen">
			<div class="mask" @click="videoOpen = false"></div>
			<div class="content">
				<div class="title">Результаты конкурса</div>
				<uiDevider/>
				<iframe
					width="560"
					height="315"
					src="https://www.youtube.com/embed/L-q9g13Xk8s"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
				<uiDevider/>
			</div>
			<img src="@/assets/close-video.svg" class="close" @click="videoOpen = false">
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			videoOpen: true
		};
	}
};
</script>


<style lang="less" scoped>
@import "../styles.less";

.view {
	display: flex;
}

.left {
	width: 50vw;
	height: 100vh;
	background: @color-main;
	color: #000;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.title {
		font-size: 40px;
		font-weight: bold;
		margin-bottom: 30px;
		text-transform: uppercase;
		font-family: @font-title;
	}

	.text {
		width: 96%;
		font-size: 18px;
		max-width: 480px;
		line-height: 30px;
		margin-bottom: 30px;
	}

	.button {
		margin: 40px 0;
	}

	.rules {
		text-transform: uppercase;
		text-decoration: underline;
		color: #000;
	}
}

.right {
	width: 50vw;
	height: 100vh;
	background-image: url("../assets/photos/home.jpg");
	background-size: cover;
}

.video {
	width: 100vw;
	height: 100vh;
	background: fade(@color-main, 90%);
	position: absolute;
	z-index: 1000;

	.mask {
		width: 100vw;
		height: 100vh;
		position: absolute;
		cursor: pointer;
	}

	.content {
		width: 100vw;
		height: 100vh;
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		pointer-events: none;
	}

	.title {
		color: #000;
		font-size: 30px;
		font-family: @font-title;
		font-weight: bold;
		text-transform: uppercase;
		margin-bottom: 30px;
	}

	iframe {
		margin: 30px 0;
		pointer-events: all;
	}

	.close {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(310px) translateY(-230px);
	}
}

@media (max-width: 900px) {
	.view {
		flex-direction: column-reverse;
	}
	.left {
		width: 100vw;
		min-height: 65vh;
		height: auto;

		.title {
			margin-top: 30px;
		}

		.text {
			margin-bottom: 0px;
		}

		.button {
			margin-bottom: 30px;
		}

		.rules {
			text-transform: uppercase;
			text-decoration: underline;
			margin-bottom: 30px;
		}
	}

	.right {
		width: 100vw;
		height: 35vh;
		background-position: center;
	}

	.devider {
		display: none;
	}

	.video {
		iframe {
			width: 100%;
		}

		.close {
			transform: translateX(0) translateY(0);
			top: 80vh;
		}
	}
}
</style>
